module.exports = __webpack_public_path__ + "static/img/200147.0d497437.png";